import { useState } from 'react'

import Modal from '@web-ui-kit/modal'

import { useGlobalModalContext } from 'contexts/GlobalModalContext'
import CreateOrUpdateLinkForm from 'components/NavV2/shared/CreateOrUpdateLinkForm/CreateOrUpdateLinkForm'
import i18n from 'i18n'
import { isMobile } from 'utils/rebrandingUtils'
import { useWindowDimensions } from 'hooks'

const URL_REGEX = /^(http|https):\/\/[^ "]+$/

const ModalCreateOrUpdateLink = () => {
  const { store, hideModal } = useGlobalModalContext()

  const { width: windowWidth } = useWindowDimensions()

  const { modalProps } = store || {}

  const { onCancel, onConfirm, onCancelText, onConfirmText, linkDataForEdit } = modalProps || {}
  const [linkData, setLinkData] = useState(
    linkDataForEdit
      ? linkDataForEdit
      : {
          description: '',
          shared: false,
          title: '',
          url: '',
        }
  )

  const handleCancel = () => {
    if (onCancel) onCancel()

    hideModal()
  }

  const handleConfirm = () => {
    if (onConfirm) onConfirm(linkData)
  }

  const handleClose = () => {
    hideModal()
  }

  const handleChangeField = (fieldName, fieldValue) => {
    setLinkData({
      ...linkData,
      [fieldName]: fieldValue,
    })
  }

  const checkUrl = () => {
    if (linkData.url === '') return false
    return !URL_REGEX.test(linkData.url)
  }

  const isDisabledConfirm = !linkData.title || !linkData.url || checkUrl()

  const isFullScreenModal = isMobile(windowWidth)

  return (
    <Modal
      buttons={{
        contained: {
          disabled: isDisabledConfirm,
          label: onConfirmText,
          onClick: handleConfirm,
        },
        outlined: {
          label: onCancelText,
          onClick: handleCancel,
        },
      }}
      contentTitle={linkDataForEdit ? i18n.t('Editar enlace') : i18n.t('Crea un enlace')}
      handleCloseModal={handleClose}
      isSmall={isFullScreenModal}
      topNav={{
        enableCloseIcon: isFullScreenModal,
        title:
          isFullScreenModal && (linkDataForEdit ? i18n.t('Editar enlace') : i18n.t('Crear enlace')),
      }}
    >
      <CreateOrUpdateLinkForm handleChangeField={handleChangeField} linkData={linkData} />
    </Modal>
  )
}

export default ModalCreateOrUpdateLink
